export enum ExcelFileExtension {
  XLSM = ".xlsm",
  XLSX = ".xlsx",
  XLS = ".xls",
}

export const excelFileExtensionToContentType = {
  [ExcelFileExtension.XLSM]: "application/vnd.ms-excel.sheet.macroEnabled.12",
  [ExcelFileExtension.XLSX]: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  [ExcelFileExtension.XLS]: "application/vnd.ms-excel",
};
